<form [formGroup]="orderDetailsFormGroup" *ngIf="order$ | async as order">
  <div class="view-order-container">
    <glxy-alert
      *ngIf="this.shouldShowDetailsNeededBanner$ | async"
      type="warning"
      [showAction]="true"
      actionTitle="{{ 'COMMON.EDIT_ORDERS.SALES_ORDERS.VIEW_FORMS' | translate }}"
      [actionRouterLink]="'/sales-orders/' + order.businessId + '/work-order/' + order.orderId"
      data-action="view-forms"
    >
      <strong>
        {{ 'COMMON.EDIT_ORDERS.SALES_ORDERS.DETAILS_NEEDED_BANNER' | translate }}
      </strong>
      <span>-</span>
      {{ 'COMMON.EDIT_ORDERS.SALES_ORDERS.DETAILS_NEEDED_BANNER_DESCRIPTION' | translate }}
    </glxy-alert>
    <div class="main-column">
      <orders-create-order-details
        [business]="business"
        [formGroup]="orderDetailsFormGroup"
        [orderId]="order.orderId"
        [contractStartDate]="order.requestedActivation"
        [contractDuration]="order.contractDuration"
        [editingDisabled]="!!order.leasedToAutomations"
      ></orders-create-order-details>
      <orders-line-items
        #lineItems
        [business]="business"
        [specifiedLineItems]="order.lineItems"
        [editable]="true"
        [startEditing]="true"
        (lineItemsUpdated)="saveUpdatedLineItems()"
      ></orders-line-items>
      <orders-attachments
        *ngIf="!hideAttachmentsSection"
        [ngClass]="{ 'non-printable': !order.attachments }"
        [files]="order.attachments"
        [orderId]="order.orderId"
        [businessId]="order.businessId"
        [uploadUrl]="attachmentsUploadUrl"
      ></orders-attachments>
      <ng-container class="print-page-break" *ngIf="productIds">
        <business-product-activation-prereq-form
          #productPrereqForm
          [businessId]="business.accountGroupId"
          [expanded]="true"
          [productIds]="productIds"
          [orderFormOptions]="orderFormOptions$ | async"
        ></business-product-activation-prereq-form>
      </ng-container>
      <ng-container class="print-page-break" *ngIf="orderConfig$ | async as orderConfig">
        <orders-form
          #orderForm
          [order]="order"
          [orderConfig]="orderConfig"
          [userOptions]="users"
          [orderFormOptions]="orderFormOptions$ | async"
          [fileUploadUrl]="fileUploadUrl"
          [showSelfSaveButton]="!hideOrderFormSaveButton"
          [parentForm]="orderFormGroup"
          [partnerId]="order.partnerId"
          [businessId]="order.businessId"
        ></orders-form>
      </ng-container>
    </div>
    <div class="right-column" *ngIf="!hideNotesSections || !hideTagsSection">
      <orders-notes
        *ngIf="!hideNotesSections"
        [ngClass]="{ 'non-printable': !order.notes }"
        [existingNotes]="order.notes"
        [orderId]="order.orderId"
        [businessId]="order.businessId"
        [noteType]="'administrator'"
        [editingType]="!!order.leasedToAutomations ? 'disabled' : 'editingonly'"
      ></orders-notes>
      <orders-notes
        *ngIf="!hideNotesSections"
        [ngClass]="{ 'non-printable': !order.customerNotes }"
        [existingNotes]="order.customerNotes"
        [orderId]="order.orderId"
        [businessId]="order.businessId"
        [noteType]="'customer'"
        [editingType]="!!order.leasedToAutomations ? 'disabled' : 'editingonly'"
      ></orders-notes>
      <ng-container *ngIf="orderConfig$ | async as orderConfig">
        <orders-tags
          *ngIf="orderConfig.salespersonOptions.disableTagging !== true && !hideTagsSection"
          [ngClass]="{ 'non-printable': !order.tags }"
          [existingOrder]="order"
          [editingType]="!!order.leasedToAutomations ? 'disabled' : 'editingonly'"
        ></orders-tags>
      </ng-container>
    </div>
  </div>
</form>
